





































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
  GetAssessFormAllColumns,
  InsertAssessFormTableColumn,
  UpdateAssessFormTableColumn,
} from "@/api/assessForm";

@Component
export default class extends AbpBase {
  @Prop() data: any;
  @Prop() value: boolean;
  saveLoading = false;
  itemList: any = []; //所有字段
  model: any = {};
  formData: any = {};
  rules: any = {
    itemId: [{ required: true, message: "请选择", trigger: "change" }],
    label: [{ required: true, message: "请输入", trigger: "blur" }],
    sort: [{ required: true, message: "请输入", trigger: "blur" }],
  };

  created() {
    this.getAllColumns();
    if (this.data.mode == "edit") {
      this.model = Object.assign({}, this.data.model);
    } else {
      this.model.formId = this.data.formData.id;
    }
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  async getAllColumns() {
    this.saveLoading = true;
    let res = await GetAssessFormAllColumns({ formId: this.data.formData.id });
    this.itemList = res.objects;
    this.saveLoading = false;
  }

  handleItemSelect(itemId: any) {
    let item = this.itemList.find((x) => x.id == itemId);
    this.model.label = item.name;
    this.model.sort = item.sort;
  }

  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        let res;
        this.saveLoading = true;
        if (this.data.mode == "edit") {
          res = await UpdateAssessFormTableColumn(this.model);
        } else {
          res = await InsertAssessFormTableColumn(this.model);
        }
        this.saveLoading = false;
        if (res.code == 2000) {
          this.$emit("input", false);
          this.$emit("save-success");
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/formBuilder/configColumnsAdd.vue